import type { ImportSourceType } from '../types/stockImports.types'

export const DEFAULT_EXPIRATION_HOURS = 120

export const STOCK_RULE_DEFAULTS = {
  maxAllowedMissingPercentage: 95,
  missingPercentageSpikeAlert: 15,
  minLoadedPercentOfMedian: 50,
  maxInvalidQuantityPercentage: 50,
  stalledAlertBusinessDays: 3,
} as const

export const isMailSourceType = (
  sourceType: ImportSourceType | '' | undefined
) => sourceType === 'EMAIL' || sourceType === 'CUSTOM_IMAP'
